"use client";
import React from "react";
import { ParcelStatus } from "@/enums";
import classNames from "classnames";
import { useTranslations } from "next-intl";
import { declarationRequiredStatusses } from "@/utils/customUtils";

const Badge = ({
  parcelStatus,
  isDetainedAtCustoms,
  isDutyCharged,
  isDeclared = undefined,
}: {
  parcelStatus?: ParcelStatus;
  isDetainedAtCustoms?: boolean;
  isDutyCharged?: boolean;
  isDeclared?: boolean;
}) => {
  const t = useTranslations();

  const isSubStatus =
    isDetainedAtCustoms ||
    isDutyCharged ||
    (!isDeclared && declarationRequiredStatusses.includes(parcelStatus));

  const showStatusText = () => {
    if (
      declarationRequiredStatusses.includes(parcelStatus) &&
      isDeclared === false
    ) {
      return "declarationRequired";
    }
    if (isDetainedAtCustoms && isDutyCharged) {
      return "dutyCharged";
    } else {
      if (isDetainedAtCustoms && !isDutyCharged) {
        return "detainedAtCustoms";
      }
    }
    // if (isDeclared === false) {
    //   return "declarationRequired";
    // }

    return parcelStatus;
  };

  return (
    <div
      className={classNames(
        "flex w-fit items-center gap-[6px] rounded-[20px] p-[10px]",
        {
          "bg-[#FFDDDD] text-[#E53238]": isSubStatus,
          "bg-[#E2F5E2]":
            (parcelStatus === ParcelStatus.COMMON_STATUS_READY_FOR_PICKUP ||
              parcelStatus === ParcelStatus.COMMON_STATUS_DELIVERED ||
              ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY) &&
            !isSubStatus,
          "bg-[#FFF3DC]":
            (parcelStatus ===
              ParcelStatus.COMMON_STATUS_TRANSFERRED_TO_NATIONAL_CARRIER ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_PROCESSED_AT_THE_INSTOCK ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_RECEIVED_AT_THE_INSTOCK) &&
            !isSubStatus,
          "bg-[#E7F6F8]":
            parcelStatus === ParcelStatus.COMMON_STATUS_DELIVERY_REQUEST &&
            !isSubStatus,
        },
      )}
    >
      <div
        className={classNames("h-[8px] w-[8px] rounded-full", {
          "bg-[#E53238]": isSubStatus,
          "bg-[#008000]":
            (parcelStatus === ParcelStatus.COMMON_STATUS_READY_FOR_PICKUP ||
              parcelStatus === ParcelStatus.COMMON_STATUS_DELIVERED ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_PREPARED_SHIPPING_FROM_FCOUNTRY ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY) &&
            !isSubStatus,
          "bg-[#F29D01]":
            (parcelStatus ===
              ParcelStatus.COMMON_STATUS_TRANSFERRED_TO_NATIONAL_CARRIER ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_PROCESSED_AT_THE_INSTOCK ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_RECEIVED_AT_THE_INSTOCK) &&
            !isSubStatus,
          "bg-[#13CFE8]":
            parcelStatus === ParcelStatus.COMMON_STATUS_DELIVERY_REQUEST &&
            !isSubStatus,
        })}
      />
      <span
        className={classNames("line-clamp-2 truncate text-[12px] uppercase", {
          "text-[#E53238]": isSubStatus,
          "text-[#008000]":
            (parcelStatus === ParcelStatus.COMMON_STATUS_READY_FOR_PICKUP ||
              parcelStatus === ParcelStatus.COMMON_STATUS_DELIVERED ||
              ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY) &&
            !isSubStatus,
          "text-[#F29D01]":
            (parcelStatus ===
              ParcelStatus.COMMON_STATUS_TRANSFERRED_TO_NATIONAL_CARRIER ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_PROCESSED_AT_THE_INSTOCK ||
              parcelStatus ===
                ParcelStatus.COMMON_STATUS_RECEIVED_AT_THE_INSTOCK) &&
            !isSubStatus,
          "text-[#13CFE8]":
            parcelStatus === ParcelStatus.COMMON_STATUS_DELIVERY_REQUEST &&
            !isSubStatus,
        })}
      >
        {isSubStatus || parcelStatus ? t(showStatusText()) : null}
      </span>
    </div>
  );
};

export default Badge;
